<template>
    <v-row>
        <v-col cols="12">
            <v-card>
                <v-card-title>
                    <span class="text-green">
                        PAGAMENTO EFETUADO COM SUCESSO
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="orderedItems" class="elevation-1" fixed-header
                        height="44vh" :items-per-page="-1" hide-default-footer>
                        <template v-slot:bottom>
                            <v-row class="my-3">
                                <v-col cols="2">
                                    <div class="text-left">Itens</div>
                                </v-col>
                                <v-col cols="2">
                                    <div class="text-right">{{ checkout?.invoices?.length }}</div>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                    <div class="text-left">Valor Total</div>
                                </v-col>
                                <v-col cols="2">
                                    <div class="text-right">{{ $filters.currency(checkout.due_amount, 'BRL') }}</div>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.person="row">
                            <span>{{ calcPerson(row.item) }}</span>
                        </template>
                        <template v-slot:item.payment_date="row">
                            <span :class="getTextColorClassFromInvoiceDueDate(row.item)">{{
                                $moment.parseZone(row.value || new Date()).format("DD/MM/YYYY")
                                }}</span>
                        </template>
                        <template v-slot:item.due_date="row">
                            <span :class="getTextColorClassFromInvoiceDueDate(row.item)">{{
                                $moment.parseZone(row.value).format("DD/MM/YYYY")
                                }}</span>
                        </template>
                        <template v-slot:item.amount="row">
                            <span>{{
                                $filters.currency(getAmountFromInvoice(row.item), 'BRL')
                                }}</span>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
export default {
    props: {
        checkout: Object
    },
    data() {
        return {
            headers: [
                { title: "Descrição", align: "start", key: "description", sortable: false },
                { title: "Vencimento", align: "end", key: "due_date", sortable: false },
                { title: "Pagamento", align: "end", key: "payment_date", sortable: false },
                { title: "Nome", align: "start", key: "person", sortable: false },
                { title: "Valor", align: "end", key: "amount", sortable: false },
            ]
        };
    },
    computed: {
        orderedItems() {
            const vm = this;
            return vm.checkout.invoices.sort((a, b) => {
                const sameFrom = a.from.id === b.from.id;

                if (sameFrom) {
                    const sameTo = a.to.id === b.to.id;

                    if (sameTo) {
                        return vm.$moment.parseZone(a.due_date).format('YYYYMMDD') - vm.$moment.parseZone(b.due_date).format('YYYYMMDD');
                    }
                    return a.to.name.localeCompare(b.to.name);
                }
                return a.from.name.localeCompare(b.from.name);
            });
        }
    },
    methods: {
        calcPerson(invoice) {
            return invoice?.from?.type == 13 ? invoice?.to?.name : invoice?.from?.name;
        },
        getAmountFromInvoice(invoice) {
            var vm = this;
            if (invoice.paid_amount) {
                return invoice.paid_amount;
            } else {
                let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
                let _today = vm.$moment.parseZone().startOf("day");
                let _amount = invoice.amount;
                if (_dueDate > _today) {
                    _amount -= invoice.early_payment_discount || 0
                } else if (
                    _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
                ) {
                    _amount -= invoice.early_payment_discount || 0
                }
                return _amount
            }
        },
        getTextColorClassFromInvoiceDueDate(invoice) {
            var vm = this;
            let _class = "";
            if (invoice.status == vm.$INVOICE_STATUS_DIC.CANCELED.value) {
                _class = "";
            } else {
                let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
                if (invoice.payment_date) {
                    let _paymentDate = vm.$moment
                        .parseZone(invoice.payment_date)
                        .local()
                        .startOf("day");
                    if (_dueDate < _paymentDate) {
                        _class = "text-red";
                    } else if (
                        _dueDate.format("DD/MM/YYYY") == _paymentDate.format("DD/MM/YYYY")
                    ) {
                        _class = "text-orange";
                    } else if (_dueDate > _paymentDate) {
                        _class = "text-green";
                    }
                } else {
                    let _today = vm.$moment.parseZone().startOf("day");
                    if (_dueDate < _today) {
                        _class = "text-red";
                    } else if (
                        _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
                    ) {
                        _class = "text-orange";
                    } else if (_dueDate > _today) {
                        _class = "text-blue";
                    }
                }
            }
            return _class;
        }
    }
};
</script>